import { forwardRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "nlpd-cookie-banner-dismissed";

const CookieBanner = forwardRef<HTMLDivElement>((_, ref) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      /* noop */
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* noop */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      ref={ref}
      role="region"
      aria-label="Information sur la confidentialité"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-2xl bg-card border shadow-lg rounded-lg p-4 flex flex-col sm:flex-row items-start sm:items-center gap-3 text-sm"
    >
      <p className="flex-1 text-muted-foreground">
        Ce site n'utilise <strong>aucun cookie d'analyse, de publicité ou de profilage</strong>.
        Seuls quelques cookies essentiels (session du compte Pro, protection anti-bot Cloudflare) et
        le stockage local de votre navigateur sont utilisés. Voir{" "}
        <Link to="/politique-de-confidentialite" className="text-primary hover:underline">
          la politique de confidentialité
        </Link>.
      </p>
      <Button size="sm" onClick={dismiss} className="shrink-0">
        Compris
      </Button>
    </div>
  );
});
CookieBanner.displayName = 'CookieBanner';

export default CookieBanner;
